function tinyHeader() {
    var scrollTop = document.body.getBoundingClientRect().top || document.documentElement.scrollTop;

    //petit logo
    if (scrollTop < -20) {
        $headerLogo.addClass('tiny');
    }
    else {
        $headerLogo.removeClass('tiny');
    }


    //petit logo
    if (scrollTop < -40) {
        $header.removeClass('near-top');
    }
    else {
        $header.addClass('near-top');
    }

    //affiche / masque le header au scroll / retour au haut de page
    if(scrollTop === 0){
        $header.removeClass('scroll-down').removeClass('scroll-up');
    }
    else if( scrollTop > -350){
        $header.removeClass('scroll-down').removeClass('scroll-up');
    }
    else if (scrollTop > lastScrollPos){
        if(scrollDirection !== 'up'){
            $header.removeClass('scroll-down').addClass('scroll-up');
        }
        scrollDirection = 'up';
    }
    else {
        if(scrollDirection !== 'down' ){
            $header.removeClass('scroll-up').addClass('scroll-down');
        }
        scrollDirection = 'down';
    }
    lastScrollPos = scrollTop;
}

function initHeader(){
    $('.header-toggle-menu').on('click',function () {
        $('.main-header').toggleClass('menu-open');
    });

}